import {
    Component,
    computed,
    inject,
    input,
    OnChanges,
    OnDestroy,
    signal,
    SimpleChanges,
} from '@angular/core';

import { ZplRendererService } from '../services/zpl-renderer.service';
import { Subscription } from 'rxjs';
import { IconModule } from '@pf/shared-ui';
import { asNumberSafe, downloadBase64ImageUrl } from '@pf/shared-utility';

@Component({
    selector: 'platform-zpl-preview',
    imports: [IconModule],
    standalone: true,
    templateUrl: './zpl-preview.component.html',
    styleUrl: './zpl-preview.component.scss',
    host: {
        '[class.landscape]': 'isLandscape()',
        '[class.portrait]': '!isLandscape()',
    },
})
export class ZplPreviewComponent implements OnChanges, OnDestroy {
    fileName = input.required<string>();
    zpl = input.required<string>();
    widthInches = input<number | undefined>();
    heightInches = input<number | undefined>();

    private readonly zplRendererService = inject(ZplRendererService);
    private subscription: Subscription | undefined;

    imageUrl = signal<string | null>(null);
    error = signal<string | null>(null);
    lightboxOpen = signal(false);

    isLandscape = computed(() => {
        const w = asNumberSafe(this.widthInches() || 4);
        const h = asNumberSafe(this.heightInches() || 2);
        return w >= h;
    });

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['zpl']) {
            this.renderPreview();
        }
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    private renderPreview(): void {
        this.error.set(null);
        this.imageUrl.set(null);

        this.subscription?.unsubscribe();

        const width = asNumberSafe(this.widthInches() || 4) * 25.4;
        const height = asNumberSafe(this.heightInches() || 2) * 25.4;
        this.subscription = this.zplRendererService
            .renderZpl({ zpl: this.zpl(), wmm: width, hmm: height })
            .subscribe(result => {
                if (result.ok && result.b64) {
                    this.imageUrl.set('data:image/png;base64,' + result.b64);
                } else if (result.error) {
                    this.error.set(result.error);
                }
            });
    }

    openLightbox() {
        this.lightboxOpen.set(true);
    }

    closeLightbox() {
        this.lightboxOpen.set(false);
    }

    downloadImage() {
        const imageUrl = this.imageUrl();
        if (!imageUrl) {
            return;
        }
        const fileName = this.fileName().split('.').shift();
        downloadBase64ImageUrl(imageUrl, fileName + '.png');
    }
}
